<div class="relative group">
  <!-- SVG Icon Trigger -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    class="w-5 h-5 text-[#1B9ED1]"
    (mouseenter)="isVisible = true"
    (mouseleave)="isVisible = false"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    />
  </svg>

  <!-- Tooltip -->
  <div
    *ngIf="isVisible"
    class="absolute top-4 left-1/2 -translate-x-1/2 mt-2 bg-[#1B9ED1] text-white px-4 py-2 rounded shadow-lg z-50 whitespace-nowrap"
  >
    <h3 class="font-semibold text-white mb-1">Title</h3>
    <p class="text-white">Description</p>
  </div>
</div>
